/* eslint-disable import/no-anonymous-default-export */
import { Navigate, RouteObject } from "react-router-dom";
import {
  SUBSCRIPTION_APPROVAL,
  SUBSCRIPTION_APPROVAL_DETAILS,
  SUBSCRIPTION_APPROVAL_OVERVIEW,
} from "../../constants/urls";

/** @type {import('react-router-dom').RouteObject[]} */
export default [
  {
    path: SUBSCRIPTION_APPROVAL,
    lazy: () => import("./routes/SubscriptionApprovalOverview"),
  },

  //   {
  //     path: SUBSCRIPTION_APPROVAL_OVERVIEW,
  //     lazy: () => import("./routes/SubscriptionApprovalOverview"),
  //   },
  {
    path: SUBSCRIPTION_APPROVAL_DETAILS,
    lazy: () => import("./routes/SubscriptionApprovalDetails"),
  },
] as RouteObject[];
